import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './share.less'
import ShareCampaign from 'components/common/share_campaign'
import { getI18n } from 'client/i18n'

const i18n = getI18n('components/share')

class Share extends React.Component {
  static propTypes = {
    campaignId: PropTypes.string,
    onClickOverride: PropTypes.func,
  }

  render() {
    return (
      <div styleName="share">
        <div styleName="title">{i18n('title')}</div>
        <ShareCampaign
          campaignId={this.props.campaignId}
          onClickOverride={this.props.onClickOverride}
        />
      </div>
    )
  }
}

export default cssModules(Share, styles)
